export default __webpack_public_path__ + "static/media/img8.c7197588.png";